export default "__VITE_ASSET__aASfcrUu__"